/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Potencia = ($root.Potencia = (() => {
  /**
   * Properties of a Potencia.
   * @exports IPotencia
   * @interface IPotencia
   * @property {number|null} [tx] Potencia tx
   * @property {number|null} [rx] Potencia rx
   */

  /**
   * Constructs a new Potencia.
   * @exports Potencia
   * @classdesc Represents a Potencia.
   * @implements IPotencia
   * @constructor
   * @param {IPotencia=} [properties] Properties to set
   */
  function Potencia(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Potencia tx.
   * @member {number} tx
   * @memberof Potencia
   * @instance
   */
  Potencia.prototype.tx = 0;

  /**
   * Potencia rx.
   * @member {number} rx
   * @memberof Potencia
   * @instance
   */
  Potencia.prototype.rx = 0;

  /**
   * Creates a new Potencia instance using the specified properties.
   * @function create
   * @memberof Potencia
   * @static
   * @param {IPotencia=} [properties] Properties to set
   * @returns {Potencia} Potencia instance
   */
  Potencia.create = function create(properties) {
    return new Potencia(properties);
  };

  /**
   * Encodes the specified Potencia message. Does not implicitly {@link Potencia.verify|verify} messages.
   * @function encode
   * @memberof Potencia
   * @static
   * @param {IPotencia} message Potencia message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Potencia.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.tx != null && Object.hasOwnProperty.call(message, "tx"))
      writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.tx);
    if (message.rx != null && Object.hasOwnProperty.call(message, "rx"))
      writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.rx);
    return writer;
  };

  /**
   * Encodes the specified Potencia message, length delimited. Does not implicitly {@link Potencia.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Potencia
   * @static
   * @param {IPotencia} message Potencia message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Potencia.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Potencia message from the specified reader or buffer.
   * @function decode
   * @memberof Potencia
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Potencia} Potencia
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Potencia.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Potencia();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.tx = reader.double();
          break;
        }
        case 2: {
          message.rx = reader.double();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Potencia message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Potencia
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Potencia} Potencia
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Potencia.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Potencia message.
   * @function verify
   * @memberof Potencia
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Potencia.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.tx != null && message.hasOwnProperty("tx"))
      if (typeof message.tx !== "number") return "tx: number expected";
    if (message.rx != null && message.hasOwnProperty("rx"))
      if (typeof message.rx !== "number") return "rx: number expected";
    return null;
  };

  /**
   * Creates a Potencia message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Potencia
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Potencia} Potencia
   */
  Potencia.fromObject = function fromObject(object) {
    if (object instanceof $root.Potencia) return object;
    let message = new $root.Potencia();
    if (object.tx != null) message.tx = Number(object.tx);
    if (object.rx != null) message.rx = Number(object.rx);
    return message;
  };

  /**
   * Creates a plain object from a Potencia message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Potencia
   * @static
   * @param {Potencia} message Potencia
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Potencia.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.tx = 0;
      object.rx = 0;
    }
    if (message.tx != null && message.hasOwnProperty("tx"))
      object.tx =
        options.json && !isFinite(message.tx) ? String(message.tx) : message.tx;
    if (message.rx != null && message.hasOwnProperty("rx"))
      object.rx =
        options.json && !isFinite(message.rx) ? String(message.rx) : message.rx;
    return object;
  };

  /**
   * Converts this Potencia to JSON.
   * @function toJSON
   * @memberof Potencia
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Potencia.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Potencia
   * @function getTypeUrl
   * @memberof Potencia
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Potencia.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Potencia";
  };

  return Potencia;
})());

export const Status = ($root.Status = (() => {
  /**
   * Properties of a Status.
   * @exports IStatus
   * @interface IStatus
   * @property {number|null} [value] Status value
   */

  /**
   * Constructs a new Status.
   * @exports Status
   * @classdesc Represents a Status.
   * @implements IStatus
   * @constructor
   * @param {IStatus=} [properties] Properties to set
   */
  function Status(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Status value.
   * @member {number} value
   * @memberof Status
   * @instance
   */
  Status.prototype.value = 0;

  /**
   * Creates a new Status instance using the specified properties.
   * @function create
   * @memberof Status
   * @static
   * @param {IStatus=} [properties] Properties to set
   * @returns {Status} Status instance
   */
  Status.create = function create(properties) {
    return new Status(properties);
  };

  /**
   * Encodes the specified Status message. Does not implicitly {@link Status.verify|verify} messages.
   * @function encode
   * @memberof Status
   * @static
   * @param {IStatus} message Status message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Status.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
      writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.value);
    return writer;
  };

  /**
   * Encodes the specified Status message, length delimited. Does not implicitly {@link Status.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Status
   * @static
   * @param {IStatus} message Status message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Status.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Status message from the specified reader or buffer.
   * @function decode
   * @memberof Status
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Status} Status
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Status.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Status();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.value = reader.int32();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Status message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Status
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Status} Status
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Status.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Status message.
   * @function verify
   * @memberof Status
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Status.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.value != null && message.hasOwnProperty("value"))
      if (!$util.isInteger(message.value)) return "value: integer expected";
    return null;
  };

  /**
   * Creates a Status message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Status
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Status} Status
   */
  Status.fromObject = function fromObject(object) {
    if (object instanceof $root.Status) return object;
    let message = new $root.Status();
    if (object.value != null) message.value = object.value | 0;
    return message;
  };

  /**
   * Creates a plain object from a Status message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Status
   * @static
   * @param {Status} message Status
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Status.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) object.value = 0;
    if (message.value != null && message.hasOwnProperty("value"))
      object.value = message.value;
    return object;
  };

  /**
   * Converts this Status to JSON.
   * @function toJSON
   * @memberof Status
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Status.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Status
   * @function getTypeUrl
   * @memberof Status
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Status";
  };

  return Status;
})());

export const Usuario = ($root.Usuario = (() => {
  /**
   * Properties of a Usuario.
   * @exports IUsuario
   * @interface IUsuario
   * @property {string|null} [value] Usuario value
   * @property {string|null} [unit] Usuario unit
   */

  /**
   * Constructs a new Usuario.
   * @exports Usuario
   * @classdesc Represents a Usuario.
   * @implements IUsuario
   * @constructor
   * @param {IUsuario=} [properties] Properties to set
   */
  function Usuario(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Usuario value.
   * @member {string} value
   * @memberof Usuario
   * @instance
   */
  Usuario.prototype.value = "";

  /**
   * Usuario unit.
   * @member {string} unit
   * @memberof Usuario
   * @instance
   */
  Usuario.prototype.unit = "";

  /**
   * Creates a new Usuario instance using the specified properties.
   * @function create
   * @memberof Usuario
   * @static
   * @param {IUsuario=} [properties] Properties to set
   * @returns {Usuario} Usuario instance
   */
  Usuario.create = function create(properties) {
    return new Usuario(properties);
  };

  /**
   * Encodes the specified Usuario message. Does not implicitly {@link Usuario.verify|verify} messages.
   * @function encode
   * @memberof Usuario
   * @static
   * @param {IUsuario} message Usuario message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Usuario.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.value);
    if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.unit);
    return writer;
  };

  /**
   * Encodes the specified Usuario message, length delimited. Does not implicitly {@link Usuario.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Usuario
   * @static
   * @param {IUsuario} message Usuario message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Usuario.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Usuario message from the specified reader or buffer.
   * @function decode
   * @memberof Usuario
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Usuario} Usuario
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Usuario.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Usuario();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.value = reader.string();
          break;
        }
        case 2: {
          message.unit = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Usuario message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Usuario
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Usuario} Usuario
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Usuario.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Usuario message.
   * @function verify
   * @memberof Usuario
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Usuario.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.value != null && message.hasOwnProperty("value"))
      if (!$util.isString(message.value)) return "value: string expected";
    if (message.unit != null && message.hasOwnProperty("unit"))
      if (!$util.isString(message.unit)) return "unit: string expected";
    return null;
  };

  /**
   * Creates a Usuario message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Usuario
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Usuario} Usuario
   */
  Usuario.fromObject = function fromObject(object) {
    if (object instanceof $root.Usuario) return object;
    let message = new $root.Usuario();
    if (object.value != null) message.value = String(object.value);
    if (object.unit != null) message.unit = String(object.unit);
    return message;
  };

  /**
   * Creates a plain object from a Usuario message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Usuario
   * @static
   * @param {Usuario} message Usuario
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Usuario.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.value = "";
      object.unit = "";
    }
    if (message.value != null && message.hasOwnProperty("value"))
      object.value = message.value;
    if (message.unit != null && message.hasOwnProperty("unit"))
      object.unit = message.unit;
    return object;
  };

  /**
   * Converts this Usuario to JSON.
   * @function toJSON
   * @memberof Usuario
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Usuario.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Usuario
   * @function getTypeUrl
   * @memberof Usuario
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Usuario.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Usuario";
  };

  return Usuario;
})());

export const Contrato = ($root.Contrato = (() => {
  /**
   * Properties of a Contrato.
   * @exports IContrato
   * @interface IContrato
   * @property {number|null} [value] Contrato value
   * @property {string|null} [unit] Contrato unit
   */

  /**
   * Constructs a new Contrato.
   * @exports Contrato
   * @classdesc Represents a Contrato.
   * @implements IContrato
   * @constructor
   * @param {IContrato=} [properties] Properties to set
   */
  function Contrato(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Contrato value.
   * @member {number} value
   * @memberof Contrato
   * @instance
   */
  Contrato.prototype.value = 0;

  /**
   * Contrato unit.
   * @member {string} unit
   * @memberof Contrato
   * @instance
   */
  Contrato.prototype.unit = "";

  /**
   * Creates a new Contrato instance using the specified properties.
   * @function create
   * @memberof Contrato
   * @static
   * @param {IContrato=} [properties] Properties to set
   * @returns {Contrato} Contrato instance
   */
  Contrato.create = function create(properties) {
    return new Contrato(properties);
  };

  /**
   * Encodes the specified Contrato message. Does not implicitly {@link Contrato.verify|verify} messages.
   * @function encode
   * @memberof Contrato
   * @static
   * @param {IContrato} message Contrato message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Contrato.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
      writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.value);
    if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.unit);
    return writer;
  };

  /**
   * Encodes the specified Contrato message, length delimited. Does not implicitly {@link Contrato.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Contrato
   * @static
   * @param {IContrato} message Contrato message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Contrato.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Contrato message from the specified reader or buffer.
   * @function decode
   * @memberof Contrato
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Contrato} Contrato
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Contrato.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Contrato();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.value = reader.int32();
          break;
        }
        case 2: {
          message.unit = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Contrato message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Contrato
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Contrato} Contrato
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Contrato.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Contrato message.
   * @function verify
   * @memberof Contrato
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Contrato.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.value != null && message.hasOwnProperty("value"))
      if (!$util.isInteger(message.value)) return "value: integer expected";
    if (message.unit != null && message.hasOwnProperty("unit"))
      if (!$util.isString(message.unit)) return "unit: string expected";
    return null;
  };

  /**
   * Creates a Contrato message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Contrato
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Contrato} Contrato
   */
  Contrato.fromObject = function fromObject(object) {
    if (object instanceof $root.Contrato) return object;
    let message = new $root.Contrato();
    if (object.value != null) message.value = object.value | 0;
    if (object.unit != null) message.unit = String(object.unit);
    return message;
  };

  /**
   * Creates a plain object from a Contrato message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Contrato
   * @static
   * @param {Contrato} message Contrato
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Contrato.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.value = 0;
      object.unit = "";
    }
    if (message.value != null && message.hasOwnProperty("value"))
      object.value = message.value;
    if (message.unit != null && message.hasOwnProperty("unit"))
      object.unit = message.unit;
    return object;
  };

  /**
   * Converts this Contrato to JSON.
   * @function toJSON
   * @memberof Contrato
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Contrato.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Contrato
   * @function getTypeUrl
   * @memberof Contrato
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Contrato.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Contrato";
  };

  return Contrato;
})());

export const Data = ($root.Data = (() => {
  /**
   * Properties of a Data.
   * @exports IData
   * @interface IData
   * @property {IStatus|null} [status] Data status
   * @property {IPotencia|null} [potencia] Data potencia
   * @property {IUsuario|null} [usuario] Data usuario
   * @property {IContrato|null} [contrato] Data contrato
   */

  /**
   * Constructs a new Data.
   * @exports Data
   * @classdesc Represents a Data.
   * @implements IData
   * @constructor
   * @param {IData=} [properties] Properties to set
   */
  function Data(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Data status.
   * @member {IStatus|null|undefined} status
   * @memberof Data
   * @instance
   */
  Data.prototype.status = null;

  /**
   * Data potencia.
   * @member {IPotencia|null|undefined} potencia
   * @memberof Data
   * @instance
   */
  Data.prototype.potencia = null;

  /**
   * Data usuario.
   * @member {IUsuario|null|undefined} usuario
   * @memberof Data
   * @instance
   */
  Data.prototype.usuario = null;

  /**
   * Data contrato.
   * @member {IContrato|null|undefined} contrato
   * @memberof Data
   * @instance
   */
  Data.prototype.contrato = null;

  /**
   * Creates a new Data instance using the specified properties.
   * @function create
   * @memberof Data
   * @static
   * @param {IData=} [properties] Properties to set
   * @returns {Data} Data instance
   */
  Data.create = function create(properties) {
    return new Data(properties);
  };

  /**
   * Encodes the specified Data message. Does not implicitly {@link Data.verify|verify} messages.
   * @function encode
   * @memberof Data
   * @static
   * @param {IData} message Data message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Data.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.status != null && Object.hasOwnProperty.call(message, "status"))
      $root.Status.encode(
        message.status,
        writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
      ).ldelim();
    if (
      message.potencia != null &&
      Object.hasOwnProperty.call(message, "potencia")
    )
      $root.Potencia.encode(
        message.potencia,
        writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
      ).ldelim();
    if (
      message.usuario != null &&
      Object.hasOwnProperty.call(message, "usuario")
    )
      $root.Usuario.encode(
        message.usuario,
        writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
      ).ldelim();
    if (
      message.contrato != null &&
      Object.hasOwnProperty.call(message, "contrato")
    )
      $root.Contrato.encode(
        message.contrato,
        writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
      ).ldelim();
    return writer;
  };

  /**
   * Encodes the specified Data message, length delimited. Does not implicitly {@link Data.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Data
   * @static
   * @param {IData} message Data message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Data.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Data message from the specified reader or buffer.
   * @function decode
   * @memberof Data
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Data} Data
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Data.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Data();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.status = $root.Status.decode(reader, reader.uint32());
          break;
        }
        case 2: {
          message.potencia = $root.Potencia.decode(reader, reader.uint32());
          break;
        }
        case 3: {
          message.usuario = $root.Usuario.decode(reader, reader.uint32());
          break;
        }
        case 4: {
          message.contrato = $root.Contrato.decode(reader, reader.uint32());
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Data message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Data
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Data} Data
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Data.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Data message.
   * @function verify
   * @memberof Data
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Data.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.status != null && message.hasOwnProperty("status")) {
      let error = $root.Status.verify(message.status);
      if (error) return "status." + error;
    }
    if (message.potencia != null && message.hasOwnProperty("potencia")) {
      let error = $root.Potencia.verify(message.potencia);
      if (error) return "potencia." + error;
    }
    if (message.usuario != null && message.hasOwnProperty("usuario")) {
      let error = $root.Usuario.verify(message.usuario);
      if (error) return "usuario." + error;
    }
    if (message.contrato != null && message.hasOwnProperty("contrato")) {
      let error = $root.Contrato.verify(message.contrato);
      if (error) return "contrato." + error;
    }
    return null;
  };

  /**
   * Creates a Data message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Data
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Data} Data
   */
  Data.fromObject = function fromObject(object) {
    if (object instanceof $root.Data) return object;
    let message = new $root.Data();
    if (object.status != null) {
      if (typeof object.status !== "object")
        throw TypeError(".Data.status: object expected");
      message.status = $root.Status.fromObject(object.status);
    }
    if (object.potencia != null) {
      if (typeof object.potencia !== "object")
        throw TypeError(".Data.potencia: object expected");
      message.potencia = $root.Potencia.fromObject(object.potencia);
    }
    if (object.usuario != null) {
      if (typeof object.usuario !== "object")
        throw TypeError(".Data.usuario: object expected");
      message.usuario = $root.Usuario.fromObject(object.usuario);
    }
    if (object.contrato != null) {
      if (typeof object.contrato !== "object")
        throw TypeError(".Data.contrato: object expected");
      message.contrato = $root.Contrato.fromObject(object.contrato);
    }
    return message;
  };

  /**
   * Creates a plain object from a Data message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Data
   * @static
   * @param {Data} message Data
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Data.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.status = null;
      object.potencia = null;
      object.usuario = null;
      object.contrato = null;
    }
    if (message.status != null && message.hasOwnProperty("status"))
      object.status = $root.Status.toObject(message.status, options);
    if (message.potencia != null && message.hasOwnProperty("potencia"))
      object.potencia = $root.Potencia.toObject(message.potencia, options);
    if (message.usuario != null && message.hasOwnProperty("usuario"))
      object.usuario = $root.Usuario.toObject(message.usuario, options);
    if (message.contrato != null && message.hasOwnProperty("contrato"))
      object.contrato = $root.Contrato.toObject(message.contrato, options);
    return object;
  };

  /**
   * Converts this Data to JSON.
   * @function toJSON
   * @memberof Data
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Data.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Data
   * @function getTypeUrl
   * @memberof Data
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Data.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Data";
  };

  return Data;
})());

export const HostItem = ($root.HostItem = (() => {
  /**
   * Properties of a HostItem.
   * @exports IHostItem
   * @interface IHostItem
   * @property {string|null} [host] HostItem host
   * @property {string|null} [hostname] HostItem hostname
   * @property {string|null} [ip] HostItem ip
   */

  /**
   * Constructs a new HostItem.
   * @exports HostItem
   * @classdesc Represents a HostItem.
   * @implements IHostItem
   * @constructor
   * @param {IHostItem=} [properties] Properties to set
   */
  function HostItem(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * HostItem host.
   * @member {string} host
   * @memberof HostItem
   * @instance
   */
  HostItem.prototype.host = "";

  /**
   * HostItem hostname.
   * @member {string} hostname
   * @memberof HostItem
   * @instance
   */
  HostItem.prototype.hostname = "";

  /**
   * HostItem ip.
   * @member {string} ip
   * @memberof HostItem
   * @instance
   */
  HostItem.prototype.ip = "";

  /**
   * Creates a new HostItem instance using the specified properties.
   * @function create
   * @memberof HostItem
   * @static
   * @param {IHostItem=} [properties] Properties to set
   * @returns {HostItem} HostItem instance
   */
  HostItem.create = function create(properties) {
    return new HostItem(properties);
  };

  /**
   * Encodes the specified HostItem message. Does not implicitly {@link HostItem.verify|verify} messages.
   * @function encode
   * @memberof HostItem
   * @static
   * @param {IHostItem} message HostItem message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  HostItem.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.host != null && Object.hasOwnProperty.call(message, "host"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.host);
    if (
      message.hostname != null &&
      Object.hasOwnProperty.call(message, "hostname")
    )
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.hostname);
    if (message.ip != null && Object.hasOwnProperty.call(message, "ip"))
      writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.ip);
    return writer;
  };

  /**
   * Encodes the specified HostItem message, length delimited. Does not implicitly {@link HostItem.verify|verify} messages.
   * @function encodeDelimited
   * @memberof HostItem
   * @static
   * @param {IHostItem} message HostItem message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  HostItem.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a HostItem message from the specified reader or buffer.
   * @function decode
   * @memberof HostItem
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {HostItem} HostItem
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  HostItem.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.HostItem();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.host = reader.string();
          break;
        }
        case 2: {
          message.hostname = reader.string();
          break;
        }
        case 3: {
          message.ip = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a HostItem message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof HostItem
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {HostItem} HostItem
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  HostItem.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a HostItem message.
   * @function verify
   * @memberof HostItem
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  HostItem.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.host != null && message.hasOwnProperty("host"))
      if (!$util.isString(message.host)) return "host: string expected";
    if (message.hostname != null && message.hasOwnProperty("hostname"))
      if (!$util.isString(message.hostname)) return "hostname: string expected";
    if (message.ip != null && message.hasOwnProperty("ip"))
      if (!$util.isString(message.ip)) return "ip: string expected";
    return null;
  };

  /**
   * Creates a HostItem message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof HostItem
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {HostItem} HostItem
   */
  HostItem.fromObject = function fromObject(object) {
    if (object instanceof $root.HostItem) return object;
    let message = new $root.HostItem();
    if (object.host != null) message.host = String(object.host);
    if (object.hostname != null) message.hostname = String(object.hostname);
    if (object.ip != null) message.ip = String(object.ip);
    return message;
  };

  /**
   * Creates a plain object from a HostItem message. Also converts values to other types if specified.
   * @function toObject
   * @memberof HostItem
   * @static
   * @param {HostItem} message HostItem
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  HostItem.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.host = "";
      object.hostname = "";
      object.ip = "";
    }
    if (message.host != null && message.hasOwnProperty("host"))
      object.host = message.host;
    if (message.hostname != null && message.hasOwnProperty("hostname"))
      object.hostname = message.hostname;
    if (message.ip != null && message.hasOwnProperty("ip"))
      object.ip = message.ip;
    return object;
  };

  /**
   * Converts this HostItem to JSON.
   * @function toJSON
   * @memberof HostItem
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  HostItem.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for HostItem
   * @function getTypeUrl
   * @memberof HostItem
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  HostItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/HostItem";
  };

  return HostItem;
})());

export const HostList = ($root.HostList = (() => {
  /**
   * Properties of a HostList.
   * @exports IHostList
   * @interface IHostList
   * @property {Array.<IHostItem>|null} [hosts] HostList hosts
   */

  /**
   * Constructs a new HostList.
   * @exports HostList
   * @classdesc Represents a HostList.
   * @implements IHostList
   * @constructor
   * @param {IHostList=} [properties] Properties to set
   */
  function HostList(properties) {
    this.hosts = [];
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * HostList hosts.
   * @member {Array.<IHostItem>} hosts
   * @memberof HostList
   * @instance
   */
  HostList.prototype.hosts = $util.emptyArray;

  /**
   * Creates a new HostList instance using the specified properties.
   * @function create
   * @memberof HostList
   * @static
   * @param {IHostList=} [properties] Properties to set
   * @returns {HostList} HostList instance
   */
  HostList.create = function create(properties) {
    return new HostList(properties);
  };

  /**
   * Encodes the specified HostList message. Does not implicitly {@link HostList.verify|verify} messages.
   * @function encode
   * @memberof HostList
   * @static
   * @param {IHostList} message HostList message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  HostList.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.hosts != null && message.hosts.length)
      for (let i = 0; i < message.hosts.length; ++i)
        $root.HostItem.encode(
          message.hosts[i],
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
        ).ldelim();
    return writer;
  };

  /**
   * Encodes the specified HostList message, length delimited. Does not implicitly {@link HostList.verify|verify} messages.
   * @function encodeDelimited
   * @memberof HostList
   * @static
   * @param {IHostList} message HostList message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  HostList.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a HostList message from the specified reader or buffer.
   * @function decode
   * @memberof HostList
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {HostList} HostList
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  HostList.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.HostList();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          if (!(message.hosts && message.hosts.length)) message.hosts = [];
          message.hosts.push($root.HostItem.decode(reader, reader.uint32()));
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a HostList message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof HostList
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {HostList} HostList
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  HostList.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a HostList message.
   * @function verify
   * @memberof HostList
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  HostList.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.hosts != null && message.hasOwnProperty("hosts")) {
      if (!Array.isArray(message.hosts)) return "hosts: array expected";
      for (let i = 0; i < message.hosts.length; ++i) {
        let error = $root.HostItem.verify(message.hosts[i]);
        if (error) return "hosts." + error;
      }
    }
    return null;
  };

  /**
   * Creates a HostList message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof HostList
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {HostList} HostList
   */
  HostList.fromObject = function fromObject(object) {
    if (object instanceof $root.HostList) return object;
    let message = new $root.HostList();
    if (object.hosts) {
      if (!Array.isArray(object.hosts))
        throw TypeError(".HostList.hosts: array expected");
      message.hosts = [];
      for (let i = 0; i < object.hosts.length; ++i) {
        if (typeof object.hosts[i] !== "object")
          throw TypeError(".HostList.hosts: object expected");
        message.hosts[i] = $root.HostItem.fromObject(object.hosts[i]);
      }
    }
    return message;
  };

  /**
   * Creates a plain object from a HostList message. Also converts values to other types if specified.
   * @function toObject
   * @memberof HostList
   * @static
   * @param {HostList} message HostList
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  HostList.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.arrays || options.defaults) object.hosts = [];
    if (message.hosts && message.hosts.length) {
      object.hosts = [];
      for (let j = 0; j < message.hosts.length; ++j)
        object.hosts[j] = $root.HostItem.toObject(message.hosts[j], options);
    }
    return object;
  };

  /**
   * Converts this HostList to JSON.
   * @function toJSON
   * @memberof HostList
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  HostList.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for HostList
   * @function getTypeUrl
   * @memberof HostList
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  HostList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/HostList";
  };

  return HostList;
})());

export const ElementConfig = ($root.ElementConfig = (() => {
  /**
   * Properties of an ElementConfig.
   * @exports IElementConfig
   * @interface IElementConfig
   * @property {IHostList|null} [config] ElementConfig config
   */

  /**
   * Constructs a new ElementConfig.
   * @exports ElementConfig
   * @classdesc Represents an ElementConfig.
   * @implements IElementConfig
   * @constructor
   * @param {IElementConfig=} [properties] Properties to set
   */
  function ElementConfig(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * ElementConfig config.
   * @member {IHostList|null|undefined} config
   * @memberof ElementConfig
   * @instance
   */
  ElementConfig.prototype.config = null;

  /**
   * Creates a new ElementConfig instance using the specified properties.
   * @function create
   * @memberof ElementConfig
   * @static
   * @param {IElementConfig=} [properties] Properties to set
   * @returns {ElementConfig} ElementConfig instance
   */
  ElementConfig.create = function create(properties) {
    return new ElementConfig(properties);
  };

  /**
   * Encodes the specified ElementConfig message. Does not implicitly {@link ElementConfig.verify|verify} messages.
   * @function encode
   * @memberof ElementConfig
   * @static
   * @param {IElementConfig} message ElementConfig message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ElementConfig.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.config != null && Object.hasOwnProperty.call(message, "config"))
      $root.HostList.encode(
        message.config,
        writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
      ).ldelim();
    return writer;
  };

  /**
   * Encodes the specified ElementConfig message, length delimited. Does not implicitly {@link ElementConfig.verify|verify} messages.
   * @function encodeDelimited
   * @memberof ElementConfig
   * @static
   * @param {IElementConfig} message ElementConfig message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ElementConfig.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes an ElementConfig message from the specified reader or buffer.
   * @function decode
   * @memberof ElementConfig
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {ElementConfig} ElementConfig
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ElementConfig.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.ElementConfig();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.config = $root.HostList.decode(reader, reader.uint32());
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes an ElementConfig message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof ElementConfig
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {ElementConfig} ElementConfig
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ElementConfig.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies an ElementConfig message.
   * @function verify
   * @memberof ElementConfig
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  ElementConfig.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.config != null && message.hasOwnProperty("config")) {
      let error = $root.HostList.verify(message.config);
      if (error) return "config." + error;
    }
    return null;
  };

  /**
   * Creates an ElementConfig message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof ElementConfig
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {ElementConfig} ElementConfig
   */
  ElementConfig.fromObject = function fromObject(object) {
    if (object instanceof $root.ElementConfig) return object;
    let message = new $root.ElementConfig();
    if (object.config != null) {
      if (typeof object.config !== "object")
        throw TypeError(".ElementConfig.config: object expected");
      message.config = $root.HostList.fromObject(object.config);
    }
    return message;
  };

  /**
   * Creates a plain object from an ElementConfig message. Also converts values to other types if specified.
   * @function toObject
   * @memberof ElementConfig
   * @static
   * @param {ElementConfig} message ElementConfig
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  ElementConfig.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) object.config = null;
    if (message.config != null && message.hasOwnProperty("config"))
      object.config = $root.HostList.toObject(message.config, options);
    return object;
  };

  /**
   * Converts this ElementConfig to JSON.
   * @function toJSON
   * @memberof ElementConfig
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  ElementConfig.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for ElementConfig
   * @function getTypeUrl
   * @memberof ElementConfig
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  ElementConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/ElementConfig";
  };

  return ElementConfig;
})());

export const Coordenadas = ($root.Coordenadas = (() => {
  /**
   * Properties of a Coordenadas.
   * @exports ICoordenadas
   * @interface ICoordenadas
   * @property {number|null} [lat] Coordenadas lat
   * @property {number|null} [long] Coordenadas long
   */

  /**
   * Constructs a new Coordenadas.
   * @exports Coordenadas
   * @classdesc Represents a Coordenadas.
   * @implements ICoordenadas
   * @constructor
   * @param {ICoordenadas=} [properties] Properties to set
   */
  function Coordenadas(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Coordenadas lat.
   * @member {number} lat
   * @memberof Coordenadas
   * @instance
   */
  Coordenadas.prototype.lat = 0;

  /**
   * Coordenadas long.
   * @member {number} long
   * @memberof Coordenadas
   * @instance
   */
  Coordenadas.prototype.long = 0;

  /**
   * Creates a new Coordenadas instance using the specified properties.
   * @function create
   * @memberof Coordenadas
   * @static
   * @param {ICoordenadas=} [properties] Properties to set
   * @returns {Coordenadas} Coordenadas instance
   */
  Coordenadas.create = function create(properties) {
    return new Coordenadas(properties);
  };

  /**
   * Encodes the specified Coordenadas message. Does not implicitly {@link Coordenadas.verify|verify} messages.
   * @function encode
   * @memberof Coordenadas
   * @static
   * @param {ICoordenadas} message Coordenadas message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Coordenadas.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
      writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.lat);
    if (message.long != null && Object.hasOwnProperty.call(message, "long"))
      writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.long);
    return writer;
  };

  /**
   * Encodes the specified Coordenadas message, length delimited. Does not implicitly {@link Coordenadas.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Coordenadas
   * @static
   * @param {ICoordenadas} message Coordenadas message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Coordenadas.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Coordenadas message from the specified reader or buffer.
   * @function decode
   * @memberof Coordenadas
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Coordenadas} Coordenadas
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Coordenadas.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Coordenadas();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.lat = reader.double();
          break;
        }
        case 2: {
          message.long = reader.double();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Coordenadas message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Coordenadas
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Coordenadas} Coordenadas
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Coordenadas.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Coordenadas message.
   * @function verify
   * @memberof Coordenadas
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Coordenadas.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.lat != null && message.hasOwnProperty("lat"))
      if (typeof message.lat !== "number") return "lat: number expected";
    if (message.long != null && message.hasOwnProperty("long"))
      if (typeof message.long !== "number") return "long: number expected";
    return null;
  };

  /**
   * Creates a Coordenadas message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Coordenadas
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Coordenadas} Coordenadas
   */
  Coordenadas.fromObject = function fromObject(object) {
    if (object instanceof $root.Coordenadas) return object;
    let message = new $root.Coordenadas();
    if (object.lat != null) message.lat = Number(object.lat);
    if (object.long != null) message.long = Number(object.long);
    return message;
  };

  /**
   * Creates a plain object from a Coordenadas message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Coordenadas
   * @static
   * @param {Coordenadas} message Coordenadas
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Coordenadas.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.lat = 0;
      object.long = 0;
    }
    if (message.lat != null && message.hasOwnProperty("lat"))
      object.lat =
        options.json && !isFinite(message.lat)
          ? String(message.lat)
          : message.lat;
    if (message.long != null && message.hasOwnProperty("long"))
      object.long =
        options.json && !isFinite(message.long)
          ? String(message.long)
          : message.long;
    return object;
  };

  /**
   * Converts this Coordenadas to JSON.
   * @function toJSON
   * @memberof Coordenadas
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Coordenadas.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Coordenadas
   * @function getTypeUrl
   * @memberof Coordenadas
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Coordenadas.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Coordenadas";
  };

  return Coordenadas;
})());

export const Element = ($root.Element = (() => {
  /**
   * Properties of an Element.
   * @exports IElement
   * @interface IElement
   * @property {string|null} [id] Element id
   * @property {string|null} [idCto] Element idCto
   * @property {Array.<number>|null} [codeCity] Element codeCity
   * @property {string|null} [titulo] Element titulo
   * @property {boolean|null} [coordinateIsValid] Element coordinateIsValid
   * @property {boolean|null} [hasCto] Element hasCto
   * @property {string|null} [cto] Element cto
   * @property {string|null} [img] Element img
   * @property {IData|null} [data] Element data
   * @property {IElementConfig|null} [elementConfig] Element elementConfig
   * @property {ICoordenadas|null} [coordenadas] Element coordenadas
   * @property {Array.<IAlert>|null} [alerts] Element alerts
   * @property {number|null} [tipo] Element tipo
   * @property {number|null} [tipoBgpIxc] Element tipoBgpIxc
   * @property {string|null} [tipoElemento] Element tipoElemento
   * @property {string|null} [linkId] Element linkId
   * @property {Array.<string>|null} [onus] Element onus
   * @property {string|null} [color] Element color
   */

  /**
   * Constructs a new Element.
   * @exports Element
   * @classdesc Represents an Element.
   * @implements IElement
   * @constructor
   * @param {IElement=} [properties] Properties to set
   */
  function Element(properties) {
    this.codeCity = [];
    this.alerts = [];
    this.onus = [];
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Element id.
   * @member {string} id
   * @memberof Element
   * @instance
   */
  Element.prototype.id = "";

  /**
   * Element idCto.
   * @member {string} idCto
   * @memberof Element
   * @instance
   */
  Element.prototype.idCto = "";

  /**
   * Element codeCity.
   * @member {Array.<number>} codeCity
   * @memberof Element
   * @instance
   */
  Element.prototype.codeCity = $util.emptyArray;

  /**
   * Element titulo.
   * @member {string} titulo
   * @memberof Element
   * @instance
   */
  Element.prototype.titulo = "";

  /**
   * Element coordinateIsValid.
   * @member {boolean} coordinateIsValid
   * @memberof Element
   * @instance
   */
  Element.prototype.coordinateIsValid = false;

  /**
   * Element hasCto.
   * @member {boolean} hasCto
   * @memberof Element
   * @instance
   */
  Element.prototype.hasCto = false;

  /**
   * Element cto.
   * @member {string} cto
   * @memberof Element
   * @instance
   */
  Element.prototype.cto = "";

  /**
   * Element img.
   * @member {string} img
   * @memberof Element
   * @instance
   */
  Element.prototype.img = "";

  /**
   * Element data.
   * @member {IData|null|undefined} data
   * @memberof Element
   * @instance
   */
  Element.prototype.data = null;

  /**
   * Element elementConfig.
   * @member {IElementConfig|null|undefined} elementConfig
   * @memberof Element
   * @instance
   */
  Element.prototype.elementConfig = null;

  /**
   * Element coordenadas.
   * @member {ICoordenadas|null|undefined} coordenadas
   * @memberof Element
   * @instance
   */
  Element.prototype.coordenadas = null;

  /**
   * Element alerts.
   * @member {Array.<IAlert>} alerts
   * @memberof Element
   * @instance
   */
  Element.prototype.alerts = $util.emptyArray;

  /**
   * Element tipo.
   * @member {number} tipo
   * @memberof Element
   * @instance
   */
  Element.prototype.tipo = 0;

  /**
   * Element tipoBgpIxc.
   * @member {number} tipoBgpIxc
   * @memberof Element
   * @instance
   */
  Element.prototype.tipoBgpIxc = 0;

  /**
   * Element tipoElemento.
   * @member {string} tipoElemento
   * @memberof Element
   * @instance
   */
  Element.prototype.tipoElemento = "";

  /**
   * Element linkId.
   * @member {string} linkId
   * @memberof Element
   * @instance
   */
  Element.prototype.linkId = "";

  /**
   * Element onus.
   * @member {Array.<string>} onus
   * @memberof Element
   * @instance
   */
  Element.prototype.onus = $util.emptyArray;

  /**
   * Element color.
   * @member {string} color
   * @memberof Element
   * @instance
   */
  Element.prototype.color = "";

  /**
   * Creates a new Element instance using the specified properties.
   * @function create
   * @memberof Element
   * @static
   * @param {IElement=} [properties] Properties to set
   * @returns {Element} Element instance
   */
  Element.create = function create(properties) {
    return new Element(properties);
  };

  /**
   * Encodes the specified Element message. Does not implicitly {@link Element.verify|verify} messages.
   * @function encode
   * @memberof Element
   * @static
   * @param {IElement} message Element message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Element.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
    if (message.idCto != null && Object.hasOwnProperty.call(message, "idCto"))
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.idCto);
    if (message.codeCity != null && message.codeCity.length) {
      writer.uint32(/* id 3, wireType 2 =*/ 26).fork();
      for (let i = 0; i < message.codeCity.length; ++i)
        writer.int32(message.codeCity[i]);
      writer.ldelim();
    }
    if (message.titulo != null && Object.hasOwnProperty.call(message, "titulo"))
      writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.titulo);
    if (
      message.coordinateIsValid != null &&
      Object.hasOwnProperty.call(message, "coordinateIsValid")
    )
      writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.coordinateIsValid);
    if (message.hasCto != null && Object.hasOwnProperty.call(message, "hasCto"))
      writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.hasCto);
    if (message.cto != null && Object.hasOwnProperty.call(message, "cto"))
      writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.cto);
    if (message.img != null && Object.hasOwnProperty.call(message, "img"))
      writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.img);
    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
      $root.Data.encode(
        message.data,
        writer.uint32(/* id 9, wireType 2 =*/ 74).fork(),
      ).ldelim();
    if (
      message.elementConfig != null &&
      Object.hasOwnProperty.call(message, "elementConfig")
    )
      $root.ElementConfig.encode(
        message.elementConfig,
        writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
      ).ldelim();
    if (
      message.coordenadas != null &&
      Object.hasOwnProperty.call(message, "coordenadas")
    )
      $root.Coordenadas.encode(
        message.coordenadas,
        writer.uint32(/* id 11, wireType 2 =*/ 90).fork(),
      ).ldelim();
    if (message.alerts != null && message.alerts.length)
      for (let i = 0; i < message.alerts.length; ++i)
        $root.Alert.encode(
          message.alerts[i],
          writer.uint32(/* id 12, wireType 2 =*/ 98).fork(),
        ).ldelim();
    if (message.tipo != null && Object.hasOwnProperty.call(message, "tipo"))
      writer.uint32(/* id 13, wireType 0 =*/ 104).int32(message.tipo);
    if (
      message.tipoBgpIxc != null &&
      Object.hasOwnProperty.call(message, "tipoBgpIxc")
    )
      writer.uint32(/* id 14, wireType 0 =*/ 112).int32(message.tipoBgpIxc);
    if (
      message.tipoElemento != null &&
      Object.hasOwnProperty.call(message, "tipoElemento")
    )
      writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.tipoElemento);
    if (message.linkId != null && Object.hasOwnProperty.call(message, "linkId"))
      writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.linkId);
    if (message.onus != null && message.onus.length)
      for (let i = 0; i < message.onus.length; ++i)
        writer.uint32(/* id 17, wireType 2 =*/ 138).string(message.onus[i]);
    if (message.color != null && Object.hasOwnProperty.call(message, "color"))
      writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.color);
    return writer;
  };

  /**
   * Encodes the specified Element message, length delimited. Does not implicitly {@link Element.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Element
   * @static
   * @param {IElement} message Element message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Element.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes an Element message from the specified reader or buffer.
   * @function decode
   * @memberof Element
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Element} Element
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Element.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Element();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.id = reader.string();
          break;
        }
        case 2: {
          message.idCto = reader.string();
          break;
        }
        case 3: {
          if (!(message.codeCity && message.codeCity.length))
            message.codeCity = [];
          if ((tag & 7) === 2) {
            let end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) message.codeCity.push(reader.int32());
          } else message.codeCity.push(reader.int32());
          break;
        }
        case 4: {
          message.titulo = reader.string();
          break;
        }
        case 5: {
          message.coordinateIsValid = reader.bool();
          break;
        }
        case 6: {
          message.hasCto = reader.bool();
          break;
        }
        case 7: {
          message.cto = reader.string();
          break;
        }
        case 8: {
          message.img = reader.string();
          break;
        }
        case 9: {
          message.data = $root.Data.decode(reader, reader.uint32());
          break;
        }
        case 10: {
          message.elementConfig = $root.ElementConfig.decode(
            reader,
            reader.uint32(),
          );
          break;
        }
        case 11: {
          message.coordenadas = $root.Coordenadas.decode(
            reader,
            reader.uint32(),
          );
          break;
        }
        case 12: {
          if (!(message.alerts && message.alerts.length)) message.alerts = [];
          message.alerts.push($root.Alert.decode(reader, reader.uint32()));
          break;
        }
        case 13: {
          message.tipo = reader.int32();
          break;
        }
        case 14: {
          message.tipoBgpIxc = reader.int32();
          break;
        }
        case 15: {
          message.tipoElemento = reader.string();
          break;
        }
        case 16: {
          message.linkId = reader.string();
          break;
        }
        case 17: {
          if (!(message.onus && message.onus.length)) message.onus = [];
          message.onus.push(reader.string());
          break;
        }
        case 18: {
          message.color = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes an Element message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Element
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Element} Element
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Element.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies an Element message.
   * @function verify
   * @memberof Element
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Element.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.id != null && message.hasOwnProperty("id"))
      if (!$util.isString(message.id)) return "id: string expected";
    if (message.idCto != null && message.hasOwnProperty("idCto"))
      if (!$util.isString(message.idCto)) return "idCto: string expected";
    if (message.codeCity != null && message.hasOwnProperty("codeCity")) {
      if (!Array.isArray(message.codeCity)) return "codeCity: array expected";
      for (let i = 0; i < message.codeCity.length; ++i)
        if (!$util.isInteger(message.codeCity[i]))
          return "codeCity: integer[] expected";
    }
    if (message.titulo != null && message.hasOwnProperty("titulo"))
      if (!$util.isString(message.titulo)) return "titulo: string expected";
    if (
      message.coordinateIsValid != null &&
      message.hasOwnProperty("coordinateIsValid")
    )
      if (typeof message.coordinateIsValid !== "boolean")
        return "coordinateIsValid: boolean expected";
    if (message.hasCto != null && message.hasOwnProperty("hasCto"))
      if (typeof message.hasCto !== "boolean")
        return "hasCto: boolean expected";
    if (message.cto != null && message.hasOwnProperty("cto"))
      if (!$util.isString(message.cto)) return "cto: string expected";
    if (message.img != null && message.hasOwnProperty("img"))
      if (!$util.isString(message.img)) return "img: string expected";
    if (message.data != null && message.hasOwnProperty("data")) {
      let error = $root.Data.verify(message.data);
      if (error) return "data." + error;
    }
    if (
      message.elementConfig != null &&
      message.hasOwnProperty("elementConfig")
    ) {
      let error = $root.ElementConfig.verify(message.elementConfig);
      if (error) return "elementConfig." + error;
    }
    if (message.coordenadas != null && message.hasOwnProperty("coordenadas")) {
      let error = $root.Coordenadas.verify(message.coordenadas);
      if (error) return "coordenadas." + error;
    }
    if (message.alerts != null && message.hasOwnProperty("alerts")) {
      if (!Array.isArray(message.alerts)) return "alerts: array expected";
      for (let i = 0; i < message.alerts.length; ++i) {
        let error = $root.Alert.verify(message.alerts[i]);
        if (error) return "alerts." + error;
      }
    }
    if (message.tipo != null && message.hasOwnProperty("tipo"))
      if (!$util.isInteger(message.tipo)) return "tipo: integer expected";
    if (message.tipoBgpIxc != null && message.hasOwnProperty("tipoBgpIxc"))
      if (!$util.isInteger(message.tipoBgpIxc))
        return "tipoBgpIxc: integer expected";
    if (message.tipoElemento != null && message.hasOwnProperty("tipoElemento"))
      if (!$util.isString(message.tipoElemento))
        return "tipoElemento: string expected";
    if (message.linkId != null && message.hasOwnProperty("linkId"))
      if (!$util.isString(message.linkId)) return "linkId: string expected";
    if (message.onus != null && message.hasOwnProperty("onus")) {
      if (!Array.isArray(message.onus)) return "onus: array expected";
      for (let i = 0; i < message.onus.length; ++i)
        if (!$util.isString(message.onus[i])) return "onus: string[] expected";
    }
    if (message.color != null && message.hasOwnProperty("color"))
      if (!$util.isString(message.color)) return "color: string expected";
    return null;
  };

  /**
   * Creates an Element message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Element
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Element} Element
   */
  Element.fromObject = function fromObject(object) {
    if (object instanceof $root.Element) return object;
    let message = new $root.Element();
    if (object.id != null) message.id = String(object.id);
    if (object.idCto != null) message.idCto = String(object.idCto);
    if (object.codeCity) {
      if (!Array.isArray(object.codeCity))
        throw TypeError(".Element.codeCity: array expected");
      message.codeCity = [];
      for (let i = 0; i < object.codeCity.length; ++i)
        message.codeCity[i] = object.codeCity[i] | 0;
    }
    if (object.titulo != null) message.titulo = String(object.titulo);
    if (object.coordinateIsValid != null)
      message.coordinateIsValid = Boolean(object.coordinateIsValid);
    if (object.hasCto != null) message.hasCto = Boolean(object.hasCto);
    if (object.cto != null) message.cto = String(object.cto);
    if (object.img != null) message.img = String(object.img);
    if (object.data != null) {
      if (typeof object.data !== "object")
        throw TypeError(".Element.data: object expected");
      message.data = $root.Data.fromObject(object.data);
    }
    if (object.elementConfig != null) {
      if (typeof object.elementConfig !== "object")
        throw TypeError(".Element.elementConfig: object expected");
      message.elementConfig = $root.ElementConfig.fromObject(
        object.elementConfig,
      );
    }
    if (object.coordenadas != null) {
      if (typeof object.coordenadas !== "object")
        throw TypeError(".Element.coordenadas: object expected");
      message.coordenadas = $root.Coordenadas.fromObject(object.coordenadas);
    }
    if (object.alerts) {
      if (!Array.isArray(object.alerts))
        throw TypeError(".Element.alerts: array expected");
      message.alerts = [];
      for (let i = 0; i < object.alerts.length; ++i) {
        if (typeof object.alerts[i] !== "object")
          throw TypeError(".Element.alerts: object expected");
        message.alerts[i] = $root.Alert.fromObject(object.alerts[i]);
      }
    }
    if (object.tipo != null) message.tipo = object.tipo | 0;
    if (object.tipoBgpIxc != null) message.tipoBgpIxc = object.tipoBgpIxc | 0;
    if (object.tipoElemento != null)
      message.tipoElemento = String(object.tipoElemento);
    if (object.linkId != null) message.linkId = String(object.linkId);
    if (object.onus) {
      if (!Array.isArray(object.onus))
        throw TypeError(".Element.onus: array expected");
      message.onus = [];
      for (let i = 0; i < object.onus.length; ++i)
        message.onus[i] = String(object.onus[i]);
    }
    if (object.color != null) message.color = String(object.color);
    return message;
  };

  /**
   * Creates a plain object from an Element message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Element
   * @static
   * @param {Element} message Element
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Element.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.arrays || options.defaults) {
      object.codeCity = [];
      object.alerts = [];
      object.onus = [];
    }
    if (options.defaults) {
      object.id = "";
      object.idCto = "";
      object.titulo = "";
      object.coordinateIsValid = false;
      object.hasCto = false;
      object.cto = "";
      object.img = "";
      object.data = null;
      object.elementConfig = null;
      object.coordenadas = null;
      object.tipo = 0;
      object.tipoBgpIxc = 0;
      object.tipoElemento = "";
      object.linkId = "";
      object.color = "";
    }
    if (message.id != null && message.hasOwnProperty("id"))
      object.id = message.id;
    if (message.idCto != null && message.hasOwnProperty("idCto"))
      object.idCto = message.idCto;
    if (message.codeCity && message.codeCity.length) {
      object.codeCity = [];
      for (let j = 0; j < message.codeCity.length; ++j)
        object.codeCity[j] = message.codeCity[j];
    }
    if (message.titulo != null && message.hasOwnProperty("titulo"))
      object.titulo = message.titulo;
    if (
      message.coordinateIsValid != null &&
      message.hasOwnProperty("coordinateIsValid")
    )
      object.coordinateIsValid = message.coordinateIsValid;
    if (message.hasCto != null && message.hasOwnProperty("hasCto"))
      object.hasCto = message.hasCto;
    if (message.cto != null && message.hasOwnProperty("cto"))
      object.cto = message.cto;
    if (message.img != null && message.hasOwnProperty("img"))
      object.img = message.img;
    if (message.data != null && message.hasOwnProperty("data"))
      object.data = $root.Data.toObject(message.data, options);
    if (
      message.elementConfig != null &&
      message.hasOwnProperty("elementConfig")
    )
      object.elementConfig = $root.ElementConfig.toObject(
        message.elementConfig,
        options,
      );
    if (message.coordenadas != null && message.hasOwnProperty("coordenadas"))
      object.coordenadas = $root.Coordenadas.toObject(
        message.coordenadas,
        options,
      );
    if (message.alerts && message.alerts.length) {
      object.alerts = [];
      for (let j = 0; j < message.alerts.length; ++j)
        object.alerts[j] = $root.Alert.toObject(message.alerts[j], options);
    }
    if (message.tipo != null && message.hasOwnProperty("tipo"))
      object.tipo = message.tipo;
    if (message.tipoBgpIxc != null && message.hasOwnProperty("tipoBgpIxc"))
      object.tipoBgpIxc = message.tipoBgpIxc;
    if (message.tipoElemento != null && message.hasOwnProperty("tipoElemento"))
      object.tipoElemento = message.tipoElemento;
    if (message.linkId != null && message.hasOwnProperty("linkId"))
      object.linkId = message.linkId;
    if (message.onus && message.onus.length) {
      object.onus = [];
      for (let j = 0; j < message.onus.length; ++j)
        object.onus[j] = message.onus[j];
    }
    if (message.color != null && message.hasOwnProperty("color"))
      object.color = message.color;
    return object;
  };

  /**
   * Converts this Element to JSON.
   * @function toJSON
   * @memberof Element
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Element.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Element
   * @function getTypeUrl
   * @memberof Element
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Element.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Element";
  };

  return Element;
})());

export const Alert = ($root.Alert = (() => {
  /**
   * Properties of an Alert.
   * @exports IAlert
   * @interface IAlert
   * @property {string|null} [id] Alert id
   * @property {string|null} [text] Alert text
   * @property {number|null} [severity] Alert severity
   * @property {string|null} [titulo] Alert titulo
   * @property {string|null} [clock] Alert clock
   */

  /**
   * Constructs a new Alert.
   * @exports Alert
   * @classdesc Represents an Alert.
   * @implements IAlert
   * @constructor
   * @param {IAlert=} [properties] Properties to set
   */
  function Alert(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Alert id.
   * @member {string} id
   * @memberof Alert
   * @instance
   */
  Alert.prototype.id = "";

  /**
   * Alert text.
   * @member {string} text
   * @memberof Alert
   * @instance
   */
  Alert.prototype.text = "";

  /**
   * Alert severity.
   * @member {number} severity
   * @memberof Alert
   * @instance
   */
  Alert.prototype.severity = 0;

  /**
   * Alert titulo.
   * @member {string} titulo
   * @memberof Alert
   * @instance
   */
  Alert.prototype.titulo = "";

  /**
   * Alert clock.
   * @member {string} clock
   * @memberof Alert
   * @instance
   */
  Alert.prototype.clock = "";

  /**
   * Creates a new Alert instance using the specified properties.
   * @function create
   * @memberof Alert
   * @static
   * @param {IAlert=} [properties] Properties to set
   * @returns {Alert} Alert instance
   */
  Alert.create = function create(properties) {
    return new Alert(properties);
  };

  /**
   * Encodes the specified Alert message. Does not implicitly {@link Alert.verify|verify} messages.
   * @function encode
   * @memberof Alert
   * @static
   * @param {IAlert} message Alert message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Alert.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
    if (message.text != null && Object.hasOwnProperty.call(message, "text"))
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.text);
    if (
      message.severity != null &&
      Object.hasOwnProperty.call(message, "severity")
    )
      writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.severity);
    if (message.titulo != null && Object.hasOwnProperty.call(message, "titulo"))
      writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.titulo);
    if (message.clock != null && Object.hasOwnProperty.call(message, "clock"))
      writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.clock);
    return writer;
  };

  /**
   * Encodes the specified Alert message, length delimited. Does not implicitly {@link Alert.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Alert
   * @static
   * @param {IAlert} message Alert message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Alert.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes an Alert message from the specified reader or buffer.
   * @function decode
   * @memberof Alert
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Alert} Alert
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Alert.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Alert();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.id = reader.string();
          break;
        }
        case 2: {
          message.text = reader.string();
          break;
        }
        case 3: {
          message.severity = reader.int32();
          break;
        }
        case 4: {
          message.titulo = reader.string();
          break;
        }
        case 5: {
          message.clock = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes an Alert message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Alert
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Alert} Alert
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Alert.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies an Alert message.
   * @function verify
   * @memberof Alert
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Alert.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.id != null && message.hasOwnProperty("id"))
      if (!$util.isString(message.id)) return "id: string expected";
    if (message.text != null && message.hasOwnProperty("text"))
      if (!$util.isString(message.text)) return "text: string expected";
    if (message.severity != null && message.hasOwnProperty("severity"))
      if (!$util.isInteger(message.severity))
        return "severity: integer expected";
    if (message.titulo != null && message.hasOwnProperty("titulo"))
      if (!$util.isString(message.titulo)) return "titulo: string expected";
    if (message.clock != null && message.hasOwnProperty("clock"))
      if (!$util.isString(message.clock)) return "clock: string expected";
    return null;
  };

  /**
   * Creates an Alert message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Alert
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Alert} Alert
   */
  Alert.fromObject = function fromObject(object) {
    if (object instanceof $root.Alert) return object;
    let message = new $root.Alert();
    if (object.id != null) message.id = String(object.id);
    if (object.text != null) message.text = String(object.text);
    if (object.severity != null) message.severity = object.severity | 0;
    if (object.titulo != null) message.titulo = String(object.titulo);
    if (object.clock != null) message.clock = String(object.clock);
    return message;
  };

  /**
   * Creates a plain object from an Alert message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Alert
   * @static
   * @param {Alert} message Alert
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Alert.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.id = "";
      object.text = "";
      object.severity = 0;
      object.titulo = "";
      object.clock = "";
    }
    if (message.id != null && message.hasOwnProperty("id"))
      object.id = message.id;
    if (message.text != null && message.hasOwnProperty("text"))
      object.text = message.text;
    if (message.severity != null && message.hasOwnProperty("severity"))
      object.severity = message.severity;
    if (message.titulo != null && message.hasOwnProperty("titulo"))
      object.titulo = message.titulo;
    if (message.clock != null && message.hasOwnProperty("clock"))
      object.clock = message.clock;
    return object;
  };

  /**
   * Converts this Alert to JSON.
   * @function toJSON
   * @memberof Alert
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Alert.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Alert
   * @function getTypeUrl
   * @memberof Alert
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Alert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Alert";
  };

  return Alert;
})());

export const ConnectionPotencia = ($root.ConnectionPotencia = (() => {
  /**
   * Properties of a ConnectionPotencia.
   * @exports IConnectionPotencia
   * @interface IConnectionPotencia
   * @property {number|null} [tx] ConnectionPotencia tx
   * @property {number|null} [rx] ConnectionPotencia rx
   */

  /**
   * Constructs a new ConnectionPotencia.
   * @exports ConnectionPotencia
   * @classdesc Represents a ConnectionPotencia.
   * @implements IConnectionPotencia
   * @constructor
   * @param {IConnectionPotencia=} [properties] Properties to set
   */
  function ConnectionPotencia(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * ConnectionPotencia tx.
   * @member {number} tx
   * @memberof ConnectionPotencia
   * @instance
   */
  ConnectionPotencia.prototype.tx = 0;

  /**
   * ConnectionPotencia rx.
   * @member {number} rx
   * @memberof ConnectionPotencia
   * @instance
   */
  ConnectionPotencia.prototype.rx = 0;

  /**
   * Creates a new ConnectionPotencia instance using the specified properties.
   * @function create
   * @memberof ConnectionPotencia
   * @static
   * @param {IConnectionPotencia=} [properties] Properties to set
   * @returns {ConnectionPotencia} ConnectionPotencia instance
   */
  ConnectionPotencia.create = function create(properties) {
    return new ConnectionPotencia(properties);
  };

  /**
   * Encodes the specified ConnectionPotencia message. Does not implicitly {@link ConnectionPotencia.verify|verify} messages.
   * @function encode
   * @memberof ConnectionPotencia
   * @static
   * @param {IConnectionPotencia} message ConnectionPotencia message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ConnectionPotencia.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.tx != null && Object.hasOwnProperty.call(message, "tx"))
      writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.tx);
    if (message.rx != null && Object.hasOwnProperty.call(message, "rx"))
      writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.rx);
    return writer;
  };

  /**
   * Encodes the specified ConnectionPotencia message, length delimited. Does not implicitly {@link ConnectionPotencia.verify|verify} messages.
   * @function encodeDelimited
   * @memberof ConnectionPotencia
   * @static
   * @param {IConnectionPotencia} message ConnectionPotencia message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ConnectionPotencia.encodeDelimited = function encodeDelimited(
    message,
    writer,
  ) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a ConnectionPotencia message from the specified reader or buffer.
   * @function decode
   * @memberof ConnectionPotencia
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {ConnectionPotencia} ConnectionPotencia
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ConnectionPotencia.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.ConnectionPotencia();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.tx = reader.double();
          break;
        }
        case 2: {
          message.rx = reader.double();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a ConnectionPotencia message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof ConnectionPotencia
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {ConnectionPotencia} ConnectionPotencia
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ConnectionPotencia.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a ConnectionPotencia message.
   * @function verify
   * @memberof ConnectionPotencia
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  ConnectionPotencia.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.tx != null && message.hasOwnProperty("tx"))
      if (typeof message.tx !== "number") return "tx: number expected";
    if (message.rx != null && message.hasOwnProperty("rx"))
      if (typeof message.rx !== "number") return "rx: number expected";
    return null;
  };

  /**
   * Creates a ConnectionPotencia message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof ConnectionPotencia
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {ConnectionPotencia} ConnectionPotencia
   */
  ConnectionPotencia.fromObject = function fromObject(object) {
    if (object instanceof $root.ConnectionPotencia) return object;
    let message = new $root.ConnectionPotencia();
    if (object.tx != null) message.tx = Number(object.tx);
    if (object.rx != null) message.rx = Number(object.rx);
    return message;
  };

  /**
   * Creates a plain object from a ConnectionPotencia message. Also converts values to other types if specified.
   * @function toObject
   * @memberof ConnectionPotencia
   * @static
   * @param {ConnectionPotencia} message ConnectionPotencia
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  ConnectionPotencia.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.tx = 0;
      object.rx = 0;
    }
    if (message.tx != null && message.hasOwnProperty("tx"))
      object.tx =
        options.json && !isFinite(message.tx) ? String(message.tx) : message.tx;
    if (message.rx != null && message.hasOwnProperty("rx"))
      object.rx =
        options.json && !isFinite(message.rx) ? String(message.rx) : message.rx;
    return object;
  };

  /**
   * Converts this ConnectionPotencia to JSON.
   * @function toJSON
   * @memberof ConnectionPotencia
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  ConnectionPotencia.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for ConnectionPotencia
   * @function getTypeUrl
   * @memberof ConnectionPotencia
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  ConnectionPotencia.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/ConnectionPotencia";
  };

  return ConnectionPotencia;
})());

export const ConnectionConfig = ($root.ConnectionConfig = (() => {
  /**
   * Properties of a ConnectionConfig.
   * @exports IConnectionConfig
   * @interface IConnectionConfig
   * @property {string|null} [type] ConnectionConfig type
   * @property {string|null} [animation] ConnectionConfig animation
   * @property {string|null} [capacidade] ConnectionConfig capacidade
   * @property {IConnectionPotencia|null} [potencia] ConnectionConfig potencia
   * @property {string|null} [sourceHandle] ConnectionConfig sourceHandle
   * @property {string|null} [targetHandle] ConnectionConfig targetHandle
   */

  /**
   * Constructs a new ConnectionConfig.
   * @exports ConnectionConfig
   * @classdesc Represents a ConnectionConfig.
   * @implements IConnectionConfig
   * @constructor
   * @param {IConnectionConfig=} [properties] Properties to set
   */
  function ConnectionConfig(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * ConnectionConfig type.
   * @member {string} type
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.type = "";

  /**
   * ConnectionConfig animation.
   * @member {string} animation
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.animation = "";

  /**
   * ConnectionConfig capacidade.
   * @member {string} capacidade
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.capacidade = "";

  /**
   * ConnectionConfig potencia.
   * @member {IConnectionPotencia|null|undefined} potencia
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.potencia = null;

  /**
   * ConnectionConfig sourceHandle.
   * @member {string} sourceHandle
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.sourceHandle = "";

  /**
   * ConnectionConfig targetHandle.
   * @member {string} targetHandle
   * @memberof ConnectionConfig
   * @instance
   */
  ConnectionConfig.prototype.targetHandle = "";

  /**
   * Creates a new ConnectionConfig instance using the specified properties.
   * @function create
   * @memberof ConnectionConfig
   * @static
   * @param {IConnectionConfig=} [properties] Properties to set
   * @returns {ConnectionConfig} ConnectionConfig instance
   */
  ConnectionConfig.create = function create(properties) {
    return new ConnectionConfig(properties);
  };

  /**
   * Encodes the specified ConnectionConfig message. Does not implicitly {@link ConnectionConfig.verify|verify} messages.
   * @function encode
   * @memberof ConnectionConfig
   * @static
   * @param {IConnectionConfig} message ConnectionConfig message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ConnectionConfig.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
    if (
      message.animation != null &&
      Object.hasOwnProperty.call(message, "animation")
    )
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.animation);
    if (
      message.capacidade != null &&
      Object.hasOwnProperty.call(message, "capacidade")
    )
      writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.capacidade);
    if (
      message.potencia != null &&
      Object.hasOwnProperty.call(message, "potencia")
    )
      $root.ConnectionPotencia.encode(
        message.potencia,
        writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
      ).ldelim();
    if (
      message.sourceHandle != null &&
      Object.hasOwnProperty.call(message, "sourceHandle")
    )
      writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.sourceHandle);
    if (
      message.targetHandle != null &&
      Object.hasOwnProperty.call(message, "targetHandle")
    )
      writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.targetHandle);
    return writer;
  };

  /**
   * Encodes the specified ConnectionConfig message, length delimited. Does not implicitly {@link ConnectionConfig.verify|verify} messages.
   * @function encodeDelimited
   * @memberof ConnectionConfig
   * @static
   * @param {IConnectionConfig} message ConnectionConfig message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  ConnectionConfig.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a ConnectionConfig message from the specified reader or buffer.
   * @function decode
   * @memberof ConnectionConfig
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {ConnectionConfig} ConnectionConfig
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ConnectionConfig.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.ConnectionConfig();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.type = reader.string();
          break;
        }
        case 2: {
          message.animation = reader.string();
          break;
        }
        case 3: {
          message.capacidade = reader.string();
          break;
        }
        case 4: {
          message.potencia = $root.ConnectionPotencia.decode(
            reader,
            reader.uint32(),
          );
          break;
        }
        case 5: {
          message.sourceHandle = reader.string();
          break;
        }
        case 6: {
          message.targetHandle = reader.string();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a ConnectionConfig message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof ConnectionConfig
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {ConnectionConfig} ConnectionConfig
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  ConnectionConfig.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a ConnectionConfig message.
   * @function verify
   * @memberof ConnectionConfig
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  ConnectionConfig.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.type != null && message.hasOwnProperty("type"))
      if (!$util.isString(message.type)) return "type: string expected";
    if (message.animation != null && message.hasOwnProperty("animation"))
      if (!$util.isString(message.animation))
        return "animation: string expected";
    if (message.capacidade != null && message.hasOwnProperty("capacidade"))
      if (!$util.isString(message.capacidade))
        return "capacidade: string expected";
    if (message.potencia != null && message.hasOwnProperty("potencia")) {
      let error = $root.ConnectionPotencia.verify(message.potencia);
      if (error) return "potencia." + error;
    }
    if (message.sourceHandle != null && message.hasOwnProperty("sourceHandle"))
      if (!$util.isString(message.sourceHandle))
        return "sourceHandle: string expected";
    if (message.targetHandle != null && message.hasOwnProperty("targetHandle"))
      if (!$util.isString(message.targetHandle))
        return "targetHandle: string expected";
    return null;
  };

  /**
   * Creates a ConnectionConfig message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof ConnectionConfig
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {ConnectionConfig} ConnectionConfig
   */
  ConnectionConfig.fromObject = function fromObject(object) {
    if (object instanceof $root.ConnectionConfig) return object;
    let message = new $root.ConnectionConfig();
    if (object.type != null) message.type = String(object.type);
    if (object.animation != null) message.animation = String(object.animation);
    if (object.capacidade != null)
      message.capacidade = String(object.capacidade);
    if (object.potencia != null) {
      if (typeof object.potencia !== "object")
        throw TypeError(".ConnectionConfig.potencia: object expected");
      message.potencia = $root.ConnectionPotencia.fromObject(object.potencia);
    }
    if (object.sourceHandle != null)
      message.sourceHandle = String(object.sourceHandle);
    if (object.targetHandle != null)
      message.targetHandle = String(object.targetHandle);
    return message;
  };

  /**
   * Creates a plain object from a ConnectionConfig message. Also converts values to other types if specified.
   * @function toObject
   * @memberof ConnectionConfig
   * @static
   * @param {ConnectionConfig} message ConnectionConfig
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  ConnectionConfig.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) {
      object.type = "";
      object.animation = "";
      object.capacidade = "";
      object.potencia = null;
      object.sourceHandle = "";
      object.targetHandle = "";
    }
    if (message.type != null && message.hasOwnProperty("type"))
      object.type = message.type;
    if (message.animation != null && message.hasOwnProperty("animation"))
      object.animation = message.animation;
    if (message.capacidade != null && message.hasOwnProperty("capacidade"))
      object.capacidade = message.capacidade;
    if (message.potencia != null && message.hasOwnProperty("potencia"))
      object.potencia = $root.ConnectionPotencia.toObject(
        message.potencia,
        options,
      );
    if (message.sourceHandle != null && message.hasOwnProperty("sourceHandle"))
      object.sourceHandle = message.sourceHandle;
    if (message.targetHandle != null && message.hasOwnProperty("targetHandle"))
      object.targetHandle = message.targetHandle;
    return object;
  };

  /**
   * Converts this ConnectionConfig to JSON.
   * @function toJSON
   * @memberof ConnectionConfig
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  ConnectionConfig.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for ConnectionConfig
   * @function getTypeUrl
   * @memberof ConnectionConfig
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  ConnectionConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/ConnectionConfig";
  };

  return ConnectionConfig;
})());

export const Connection = ($root.Connection = (() => {
  /**
   * Properties of a Connection.
   * @exports IConnection
   * @interface IConnection
   * @property {string|null} [id] Connection id
   * @property {string|null} [referenceId] Connection referenceId
   * @property {string|null} [destinationId] Connection destinationId
   * @property {Array.<string>|null} [positionHandlers] Connection positionHandlers
   * @property {IConnectionConfig|null} [config] Connection config
   * @property {Array.<string>|null} [item] Connection item
   */

  /**
   * Constructs a new Connection.
   * @exports Connection
   * @classdesc Represents a Connection.
   * @implements IConnection
   * @constructor
   * @param {IConnection=} [properties] Properties to set
   */
  function Connection(properties) {
    this.positionHandlers = [];
    this.item = [];
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * Connection id.
   * @member {string} id
   * @memberof Connection
   * @instance
   */
  Connection.prototype.id = "";

  /**
   * Connection referenceId.
   * @member {string} referenceId
   * @memberof Connection
   * @instance
   */
  Connection.prototype.referenceId = "";

  /**
   * Connection destinationId.
   * @member {string} destinationId
   * @memberof Connection
   * @instance
   */
  Connection.prototype.destinationId = "";

  /**
   * Connection positionHandlers.
   * @member {Array.<string>} positionHandlers
   * @memberof Connection
   * @instance
   */
  Connection.prototype.positionHandlers = $util.emptyArray;

  /**
   * Connection config.
   * @member {IConnectionConfig|null|undefined} config
   * @memberof Connection
   * @instance
   */
  Connection.prototype.config = null;

  /**
   * Connection item.
   * @member {Array.<string>} item
   * @memberof Connection
   * @instance
   */
  Connection.prototype.item = $util.emptyArray;

  /**
   * Creates a new Connection instance using the specified properties.
   * @function create
   * @memberof Connection
   * @static
   * @param {IConnection=} [properties] Properties to set
   * @returns {Connection} Connection instance
   */
  Connection.create = function create(properties) {
    return new Connection(properties);
  };

  /**
   * Encodes the specified Connection message. Does not implicitly {@link Connection.verify|verify} messages.
   * @function encode
   * @memberof Connection
   * @static
   * @param {IConnection} message Connection message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Connection.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
    if (
      message.referenceId != null &&
      Object.hasOwnProperty.call(message, "referenceId")
    )
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.referenceId);
    if (
      message.destinationId != null &&
      Object.hasOwnProperty.call(message, "destinationId")
    )
      writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.destinationId);
    if (message.positionHandlers != null && message.positionHandlers.length)
      for (let i = 0; i < message.positionHandlers.length; ++i)
        writer
          .uint32(/* id 4, wireType 2 =*/ 34)
          .string(message.positionHandlers[i]);
    if (message.config != null && Object.hasOwnProperty.call(message, "config"))
      $root.ConnectionConfig.encode(
        message.config,
        writer.uint32(/* id 5, wireType 2 =*/ 42).fork(),
      ).ldelim();
    if (message.item != null && message.item.length)
      for (let i = 0; i < message.item.length; ++i)
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.item[i]);
    return writer;
  };

  /**
   * Encodes the specified Connection message, length delimited. Does not implicitly {@link Connection.verify|verify} messages.
   * @function encodeDelimited
   * @memberof Connection
   * @static
   * @param {IConnection} message Connection message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  Connection.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a Connection message from the specified reader or buffer.
   * @function decode
   * @memberof Connection
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {Connection} Connection
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Connection.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.Connection();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.id = reader.string();
          break;
        }
        case 2: {
          message.referenceId = reader.string();
          break;
        }
        case 3: {
          message.destinationId = reader.string();
          break;
        }
        case 4: {
          if (!(message.positionHandlers && message.positionHandlers.length))
            message.positionHandlers = [];
          message.positionHandlers.push(reader.string());
          break;
        }
        case 5: {
          message.config = $root.ConnectionConfig.decode(
            reader,
            reader.uint32(),
          );
          break;
        }
        case 6: {
          if (!(message.item && message.item.length)) message.item = [];
          message.item.push(reader.string());
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a Connection message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof Connection
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {Connection} Connection
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  Connection.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a Connection message.
   * @function verify
   * @memberof Connection
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  Connection.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.id != null && message.hasOwnProperty("id"))
      if (!$util.isString(message.id)) return "id: string expected";
    if (message.referenceId != null && message.hasOwnProperty("referenceId"))
      if (!$util.isString(message.referenceId))
        return "referenceId: string expected";
    if (
      message.destinationId != null &&
      message.hasOwnProperty("destinationId")
    )
      if (!$util.isString(message.destinationId))
        return "destinationId: string expected";
    if (
      message.positionHandlers != null &&
      message.hasOwnProperty("positionHandlers")
    ) {
      if (!Array.isArray(message.positionHandlers))
        return "positionHandlers: array expected";
      for (let i = 0; i < message.positionHandlers.length; ++i)
        if (!$util.isString(message.positionHandlers[i]))
          return "positionHandlers: string[] expected";
    }
    if (message.config != null && message.hasOwnProperty("config")) {
      let error = $root.ConnectionConfig.verify(message.config);
      if (error) return "config." + error;
    }
    if (message.item != null && message.hasOwnProperty("item")) {
      if (!Array.isArray(message.item)) return "item: array expected";
      for (let i = 0; i < message.item.length; ++i)
        if (!$util.isString(message.item[i])) return "item: string[] expected";
    }
    return null;
  };

  /**
   * Creates a Connection message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof Connection
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {Connection} Connection
   */
  Connection.fromObject = function fromObject(object) {
    if (object instanceof $root.Connection) return object;
    let message = new $root.Connection();
    if (object.id != null) message.id = String(object.id);
    if (object.referenceId != null)
      message.referenceId = String(object.referenceId);
    if (object.destinationId != null)
      message.destinationId = String(object.destinationId);
    if (object.positionHandlers) {
      if (!Array.isArray(object.positionHandlers))
        throw TypeError(".Connection.positionHandlers: array expected");
      message.positionHandlers = [];
      for (let i = 0; i < object.positionHandlers.length; ++i)
        message.positionHandlers[i] = String(object.positionHandlers[i]);
    }
    if (object.config != null) {
      if (typeof object.config !== "object")
        throw TypeError(".Connection.config: object expected");
      message.config = $root.ConnectionConfig.fromObject(object.config);
    }
    if (object.item) {
      if (!Array.isArray(object.item))
        throw TypeError(".Connection.item: array expected");
      message.item = [];
      for (let i = 0; i < object.item.length; ++i)
        message.item[i] = String(object.item[i]);
    }
    return message;
  };

  /**
   * Creates a plain object from a Connection message. Also converts values to other types if specified.
   * @function toObject
   * @memberof Connection
   * @static
   * @param {Connection} message Connection
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  Connection.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.arrays || options.defaults) {
      object.positionHandlers = [];
      object.item = [];
    }
    if (options.defaults) {
      object.id = "";
      object.referenceId = "";
      object.destinationId = "";
      object.config = null;
    }
    if (message.id != null && message.hasOwnProperty("id"))
      object.id = message.id;
    if (message.referenceId != null && message.hasOwnProperty("referenceId"))
      object.referenceId = message.referenceId;
    if (
      message.destinationId != null &&
      message.hasOwnProperty("destinationId")
    )
      object.destinationId = message.destinationId;
    if (message.positionHandlers && message.positionHandlers.length) {
      object.positionHandlers = [];
      for (let j = 0; j < message.positionHandlers.length; ++j)
        object.positionHandlers[j] = message.positionHandlers[j];
    }
    if (message.config != null && message.hasOwnProperty("config"))
      object.config = $root.ConnectionConfig.toObject(message.config, options);
    if (message.item && message.item.length) {
      object.item = [];
      for (let j = 0; j < message.item.length; ++j)
        object.item[j] = message.item[j];
    }
    return object;
  };

  /**
   * Converts this Connection to JSON.
   * @function toJSON
   * @memberof Connection
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  Connection.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for Connection
   * @function getTypeUrl
   * @memberof Connection
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  Connection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/Connection";
  };

  return Connection;
})());

export const City = ($root.City = (() => {
  /**
   * Properties of a City.
   * @exports ICity
   * @interface ICity
   * @property {number|null} [codigo] City codigo
   */

  /**
   * Constructs a new City.
   * @exports City
   * @classdesc Represents a City.
   * @implements ICity
   * @constructor
   * @param {ICity=} [properties] Properties to set
   */
  function City(properties) {
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * City codigo.
   * @member {number} codigo
   * @memberof City
   * @instance
   */
  City.prototype.codigo = 0;

  /**
   * Creates a new City instance using the specified properties.
   * @function create
   * @memberof City
   * @static
   * @param {ICity=} [properties] Properties to set
   * @returns {City} City instance
   */
  City.create = function create(properties) {
    return new City(properties);
  };

  /**
   * Encodes the specified City message. Does not implicitly {@link City.verify|verify} messages.
   * @function encode
   * @memberof City
   * @static
   * @param {ICity} message City message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  City.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.codigo != null && Object.hasOwnProperty.call(message, "codigo"))
      writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.codigo);
    return writer;
  };

  /**
   * Encodes the specified City message, length delimited. Does not implicitly {@link City.verify|verify} messages.
   * @function encodeDelimited
   * @memberof City
   * @static
   * @param {ICity} message City message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  City.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes a City message from the specified reader or buffer.
   * @function decode
   * @memberof City
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {City} City
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  City.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.City();
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          message.codigo = reader.int32();
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes a City message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof City
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {City} City
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  City.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies a City message.
   * @function verify
   * @memberof City
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  City.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.codigo != null && message.hasOwnProperty("codigo"))
      if (!$util.isInteger(message.codigo)) return "codigo: integer expected";
    return null;
  };

  /**
   * Creates a City message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof City
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {City} City
   */
  City.fromObject = function fromObject(object) {
    if (object instanceof $root.City) return object;
    let message = new $root.City();
    if (object.codigo != null) message.codigo = object.codigo | 0;
    return message;
  };

  /**
   * Creates a plain object from a City message. Also converts values to other types if specified.
   * @function toObject
   * @memberof City
   * @static
   * @param {City} message City
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  City.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.defaults) object.codigo = 0;
    if (message.codigo != null && message.hasOwnProperty("codigo"))
      object.codigo = message.codigo;
    return object;
  };

  /**
   * Converts this City to JSON.
   * @function toJSON
   * @memberof City
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  City.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for City
   * @function getTypeUrl
   * @memberof City
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  City.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/City";
  };

  return City;
})());

export const EasyMapsResponse = ($root.EasyMapsResponse = (() => {
  /**
   * Properties of an EasyMapsResponse.
   * @exports IEasyMapsResponse
   * @interface IEasyMapsResponse
   * @property {Array.<IElement>|null} [elements] EasyMapsResponse elements
   * @property {Array.<IConnection>|null} [connections] EasyMapsResponse connections
   * @property {Array.<IElement>|null} [invalidElements] EasyMapsResponse invalidElements
   * @property {boolean|null} [isDateRecent] EasyMapsResponse isDateRecent
   * @property {Array.<string>|null} [warningUrls] EasyMapsResponse warningUrls
   * @property {Object.<string,ICity>|null} [cities] EasyMapsResponse cities
   * @property {Array.<string>|null} [outdatedElementIds] EasyMapsResponse outdatedElementIds
   */

  /**
   * Constructs a new EasyMapsResponse.
   * @exports EasyMapsResponse
   * @classdesc Represents an EasyMapsResponse.
   * @implements IEasyMapsResponse
   * @constructor
   * @param {IEasyMapsResponse=} [properties] Properties to set
   */
  function EasyMapsResponse(properties) {
    this.elements = [];
    this.connections = [];
    this.invalidElements = [];
    this.warningUrls = [];
    this.cities = {};
    this.outdatedElementIds = [];
    if (properties)
      for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
  }

  /**
   * EasyMapsResponse elements.
   * @member {Array.<IElement>} elements
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.elements = $util.emptyArray;

  /**
   * EasyMapsResponse connections.
   * @member {Array.<IConnection>} connections
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.connections = $util.emptyArray;

  /**
   * EasyMapsResponse invalidElements.
   * @member {Array.<IElement>} invalidElements
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.invalidElements = $util.emptyArray;

  /**
   * EasyMapsResponse isDateRecent.
   * @member {boolean} isDateRecent
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.isDateRecent = false;

  /**
   * EasyMapsResponse warningUrls.
   * @member {Array.<string>} warningUrls
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.warningUrls = $util.emptyArray;

  /**
   * EasyMapsResponse cities.
   * @member {Object.<string,ICity>} cities
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.cities = $util.emptyObject;

  /**
   * EasyMapsResponse outdatedElementIds.
   * @member {Array.<string>} outdatedElementIds
   * @memberof EasyMapsResponse
   * @instance
   */
  EasyMapsResponse.prototype.outdatedElementIds = $util.emptyArray;

  /**
   * Creates a new EasyMapsResponse instance using the specified properties.
   * @function create
   * @memberof EasyMapsResponse
   * @static
   * @param {IEasyMapsResponse=} [properties] Properties to set
   * @returns {EasyMapsResponse} EasyMapsResponse instance
   */
  EasyMapsResponse.create = function create(properties) {
    return new EasyMapsResponse(properties);
  };

  /**
   * Encodes the specified EasyMapsResponse message. Does not implicitly {@link EasyMapsResponse.verify|verify} messages.
   * @function encode
   * @memberof EasyMapsResponse
   * @static
   * @param {IEasyMapsResponse} message EasyMapsResponse message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  EasyMapsResponse.encode = function encode(message, writer) {
    if (!writer) writer = $Writer.create();
    if (message.elements != null && message.elements.length)
      for (let i = 0; i < message.elements.length; ++i)
        $root.Element.encode(
          message.elements[i],
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
        ).ldelim();
    if (message.connections != null && message.connections.length)
      for (let i = 0; i < message.connections.length; ++i)
        $root.Connection.encode(
          message.connections[i],
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
        ).ldelim();
    if (message.invalidElements != null && message.invalidElements.length)
      for (let i = 0; i < message.invalidElements.length; ++i)
        $root.Element.encode(
          message.invalidElements[i],
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
        ).ldelim();
    if (
      message.isDateRecent != null &&
      Object.hasOwnProperty.call(message, "isDateRecent")
    )
      writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isDateRecent);
    if (message.warningUrls != null && message.warningUrls.length)
      for (let i = 0; i < message.warningUrls.length; ++i)
        writer
          .uint32(/* id 5, wireType 2 =*/ 42)
          .string(message.warningUrls[i]);
    if (message.cities != null && Object.hasOwnProperty.call(message, "cities"))
      for (
        let keys = Object.keys(message.cities), i = 0;
        i < keys.length;
        ++i
      ) {
        writer
          .uint32(/* id 6, wireType 2 =*/ 50)
          .fork()
          .uint32(/* id 1, wireType 2 =*/ 10)
          .string(keys[i]);
        $root.City.encode(
          message.cities[keys[i]],
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
        )
          .ldelim()
          .ldelim();
      }
    if (message.outdatedElementIds != null && message.outdatedElementIds.length)
      for (let i = 0; i < message.outdatedElementIds.length; ++i)
        writer
          .uint32(/* id 7, wireType 2 =*/ 58)
          .string(message.outdatedElementIds[i]);
    return writer;
  };

  /**
   * Encodes the specified EasyMapsResponse message, length delimited. Does not implicitly {@link EasyMapsResponse.verify|verify} messages.
   * @function encodeDelimited
   * @memberof EasyMapsResponse
   * @static
   * @param {IEasyMapsResponse} message EasyMapsResponse message or plain object to encode
   * @param {$protobuf.Writer} [writer] Writer to encode to
   * @returns {$protobuf.Writer} Writer
   */
  EasyMapsResponse.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer).ldelim();
  };

  /**
   * Decodes an EasyMapsResponse message from the specified reader or buffer.
   * @function decode
   * @memberof EasyMapsResponse
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @param {number} [length] Message length if known beforehand
   * @returns {EasyMapsResponse} EasyMapsResponse
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  EasyMapsResponse.decode = function decode(reader, length, error) {
    if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
    let end = length === undefined ? reader.len : reader.pos + length,
      message = new $root.EasyMapsResponse(),
      key,
      value;
    while (reader.pos < end) {
      let tag = reader.uint32();
      if (tag === error) break;
      switch (tag >>> 3) {
        case 1: {
          if (!(message.elements && message.elements.length))
            message.elements = [];
          message.elements.push($root.Element.decode(reader, reader.uint32()));
          break;
        }
        case 2: {
          if (!(message.connections && message.connections.length))
            message.connections = [];
          message.connections.push(
            $root.Connection.decode(reader, reader.uint32()),
          );
          break;
        }
        case 3: {
          if (!(message.invalidElements && message.invalidElements.length))
            message.invalidElements = [];
          message.invalidElements.push(
            $root.Element.decode(reader, reader.uint32()),
          );
          break;
        }
        case 4: {
          message.isDateRecent = reader.bool();
          break;
        }
        case 5: {
          if (!(message.warningUrls && message.warningUrls.length))
            message.warningUrls = [];
          message.warningUrls.push(reader.string());
          break;
        }
        case 6: {
          if (message.cities === $util.emptyObject) message.cities = {};
          let end2 = reader.uint32() + reader.pos;
          key = "";
          value = null;
          while (reader.pos < end2) {
            let tag2 = reader.uint32();
            switch (tag2 >>> 3) {
              case 1:
                key = reader.string();
                break;
              case 2:
                value = $root.City.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag2 & 7);
                break;
            }
          }
          message.cities[key] = value;
          break;
        }
        case 7: {
          if (
            !(message.outdatedElementIds && message.outdatedElementIds.length)
          )
            message.outdatedElementIds = [];
          message.outdatedElementIds.push(reader.string());
          break;
        }
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  };

  /**
   * Decodes an EasyMapsResponse message from the specified reader or buffer, length delimited.
   * @function decodeDelimited
   * @memberof EasyMapsResponse
   * @static
   * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
   * @returns {EasyMapsResponse} EasyMapsResponse
   * @throws {Error} If the payload is not a reader or valid buffer
   * @throws {$protobuf.util.ProtocolError} If required fields are missing
   */
  EasyMapsResponse.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $Reader)) reader = new $Reader(reader);
    return this.decode(reader, reader.uint32());
  };

  /**
   * Verifies an EasyMapsResponse message.
   * @function verify
   * @memberof EasyMapsResponse
   * @static
   * @param {Object.<string,*>} message Plain object to verify
   * @returns {string|null} `null` if valid, otherwise the reason why it is not
   */
  EasyMapsResponse.verify = function verify(message) {
    if (typeof message !== "object" || message === null)
      return "object expected";
    if (message.elements != null && message.hasOwnProperty("elements")) {
      if (!Array.isArray(message.elements)) return "elements: array expected";
      for (let i = 0; i < message.elements.length; ++i) {
        let error = $root.Element.verify(message.elements[i]);
        if (error) return "elements." + error;
      }
    }
    if (message.connections != null && message.hasOwnProperty("connections")) {
      if (!Array.isArray(message.connections))
        return "connections: array expected";
      for (let i = 0; i < message.connections.length; ++i) {
        let error = $root.Connection.verify(message.connections[i]);
        if (error) return "connections." + error;
      }
    }
    if (
      message.invalidElements != null &&
      message.hasOwnProperty("invalidElements")
    ) {
      if (!Array.isArray(message.invalidElements))
        return "invalidElements: array expected";
      for (let i = 0; i < message.invalidElements.length; ++i) {
        let error = $root.Element.verify(message.invalidElements[i]);
        if (error) return "invalidElements." + error;
      }
    }
    if (message.isDateRecent != null && message.hasOwnProperty("isDateRecent"))
      if (typeof message.isDateRecent !== "boolean")
        return "isDateRecent: boolean expected";
    if (message.warningUrls != null && message.hasOwnProperty("warningUrls")) {
      if (!Array.isArray(message.warningUrls))
        return "warningUrls: array expected";
      for (let i = 0; i < message.warningUrls.length; ++i)
        if (!$util.isString(message.warningUrls[i]))
          return "warningUrls: string[] expected";
    }
    if (message.cities != null && message.hasOwnProperty("cities")) {
      if (!$util.isObject(message.cities)) return "cities: object expected";
      let key = Object.keys(message.cities);
      for (let i = 0; i < key.length; ++i) {
        let error = $root.City.verify(message.cities[key[i]]);
        if (error) return "cities." + error;
      }
    }
    if (
      message.outdatedElementIds != null &&
      message.hasOwnProperty("outdatedElementIds")
    ) {
      if (!Array.isArray(message.outdatedElementIds))
        return "outdatedElementIds: array expected";
      for (let i = 0; i < message.outdatedElementIds.length; ++i)
        if (!$util.isString(message.outdatedElementIds[i]))
          return "outdatedElementIds: string[] expected";
    }
    return null;
  };

  /**
   * Creates an EasyMapsResponse message from a plain object. Also converts values to their respective internal types.
   * @function fromObject
   * @memberof EasyMapsResponse
   * @static
   * @param {Object.<string,*>} object Plain object
   * @returns {EasyMapsResponse} EasyMapsResponse
   */
  EasyMapsResponse.fromObject = function fromObject(object) {
    if (object instanceof $root.EasyMapsResponse) return object;
    let message = new $root.EasyMapsResponse();
    if (object.elements) {
      if (!Array.isArray(object.elements))
        throw TypeError(".EasyMapsResponse.elements: array expected");
      message.elements = [];
      for (let i = 0; i < object.elements.length; ++i) {
        if (typeof object.elements[i] !== "object")
          throw TypeError(".EasyMapsResponse.elements: object expected");
        message.elements[i] = $root.Element.fromObject(object.elements[i]);
      }
    }
    if (object.connections) {
      if (!Array.isArray(object.connections))
        throw TypeError(".EasyMapsResponse.connections: array expected");
      message.connections = [];
      for (let i = 0; i < object.connections.length; ++i) {
        if (typeof object.connections[i] !== "object")
          throw TypeError(".EasyMapsResponse.connections: object expected");
        message.connections[i] = $root.Connection.fromObject(
          object.connections[i],
        );
      }
    }
    if (object.invalidElements) {
      if (!Array.isArray(object.invalidElements))
        throw TypeError(".EasyMapsResponse.invalidElements: array expected");
      message.invalidElements = [];
      for (let i = 0; i < object.invalidElements.length; ++i) {
        if (typeof object.invalidElements[i] !== "object")
          throw TypeError(".EasyMapsResponse.invalidElements: object expected");
        message.invalidElements[i] = $root.Element.fromObject(
          object.invalidElements[i],
        );
      }
    }
    if (object.isDateRecent != null)
      message.isDateRecent = Boolean(object.isDateRecent);
    if (object.warningUrls) {
      if (!Array.isArray(object.warningUrls))
        throw TypeError(".EasyMapsResponse.warningUrls: array expected");
      message.warningUrls = [];
      for (let i = 0; i < object.warningUrls.length; ++i)
        message.warningUrls[i] = String(object.warningUrls[i]);
    }
    if (object.cities) {
      if (typeof object.cities !== "object")
        throw TypeError(".EasyMapsResponse.cities: object expected");
      message.cities = {};
      for (let keys = Object.keys(object.cities), i = 0; i < keys.length; ++i) {
        if (typeof object.cities[keys[i]] !== "object")
          throw TypeError(".EasyMapsResponse.cities: object expected");
        message.cities[keys[i]] = $root.City.fromObject(object.cities[keys[i]]);
      }
    }
    if (object.outdatedElementIds) {
      if (!Array.isArray(object.outdatedElementIds))
        throw TypeError(".EasyMapsResponse.outdatedElementIds: array expected");
      message.outdatedElementIds = [];
      for (let i = 0; i < object.outdatedElementIds.length; ++i)
        message.outdatedElementIds[i] = String(object.outdatedElementIds[i]);
    }
    return message;
  };

  /**
   * Creates a plain object from an EasyMapsResponse message. Also converts values to other types if specified.
   * @function toObject
   * @memberof EasyMapsResponse
   * @static
   * @param {EasyMapsResponse} message EasyMapsResponse
   * @param {$protobuf.IConversionOptions} [options] Conversion options
   * @returns {Object.<string,*>} Plain object
   */
  EasyMapsResponse.toObject = function toObject(message, options) {
    if (!options) options = {};
    let object = {};
    if (options.arrays || options.defaults) {
      object.elements = [];
      object.connections = [];
      object.invalidElements = [];
      object.warningUrls = [];
      object.outdatedElementIds = [];
    }
    if (options.objects || options.defaults) object.cities = {};
    if (options.defaults) object.isDateRecent = false;
    if (message.elements && message.elements.length) {
      object.elements = [];
      for (let j = 0; j < message.elements.length; ++j)
        object.elements[j] = $root.Element.toObject(
          message.elements[j],
          options,
        );
    }
    if (message.connections && message.connections.length) {
      object.connections = [];
      for (let j = 0; j < message.connections.length; ++j)
        object.connections[j] = $root.Connection.toObject(
          message.connections[j],
          options,
        );
    }
    if (message.invalidElements && message.invalidElements.length) {
      object.invalidElements = [];
      for (let j = 0; j < message.invalidElements.length; ++j)
        object.invalidElements[j] = $root.Element.toObject(
          message.invalidElements[j],
          options,
        );
    }
    if (message.isDateRecent != null && message.hasOwnProperty("isDateRecent"))
      object.isDateRecent = message.isDateRecent;
    if (message.warningUrls && message.warningUrls.length) {
      object.warningUrls = [];
      for (let j = 0; j < message.warningUrls.length; ++j)
        object.warningUrls[j] = message.warningUrls[j];
    }
    let keys2;
    if (message.cities && (keys2 = Object.keys(message.cities)).length) {
      object.cities = {};
      for (let j = 0; j < keys2.length; ++j)
        object.cities[keys2[j]] = $root.City.toObject(
          message.cities[keys2[j]],
          options,
        );
    }
    if (message.outdatedElementIds && message.outdatedElementIds.length) {
      object.outdatedElementIds = [];
      for (let j = 0; j < message.outdatedElementIds.length; ++j)
        object.outdatedElementIds[j] = message.outdatedElementIds[j];
    }
    return object;
  };

  /**
   * Converts this EasyMapsResponse to JSON.
   * @function toJSON
   * @memberof EasyMapsResponse
   * @instance
   * @returns {Object.<string,*>} JSON object
   */
  EasyMapsResponse.prototype.toJSON = function toJSON() {
    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
  };

  /**
   * Gets the default type url for EasyMapsResponse
   * @function getTypeUrl
   * @memberof EasyMapsResponse
   * @static
   * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
   * @returns {string} The default type url
   */
  EasyMapsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
    if (typeUrlPrefix === undefined) {
      typeUrlPrefix = "type.googleapis.com";
    }
    return typeUrlPrefix + "/EasyMapsResponse";
  };

  return EasyMapsResponse;
})());

export { $root as default };
